module.exports = __webpack_public_path__ + "a1520bca28df046942a92d445ed44c38.svg";